import React from 'react'
import { Card as SCard, List, Popup as SPopup } from 'semantic-ui-react'
import { useSelector } from '../../../hooks/useSelector'
import sum from 'lodash/sum'
import { SemanticCOLORS } from 'semantic-ui-react/dist/commonjs/generic'
import { useFocusPlayer } from '../../../hooks/useFocusPlayer'
import './PlayerStatusList.scss'
import { truncateCash } from '@prometheus/utils'
import { findCreditRatingColor } from '../../../utils/calculateBalanceSheet'
import { round } from 'lodash'
import classNames from 'classnames'
import { PlayerStatus, PlayerStatuses } from '@prometheus/types'
import { Card, Cards, Divider, Stack, Typography } from '@prometheus/components'

interface PlayerStatusListItemProps {
  player: PlayerStatus
}

export const PlayerStatusListItem = ({ player }: PlayerStatusListItemProps) => {
  const players_choosing = useSelector(s => s.game.metadata?.players_choosing_planet) || []
  const players = useSelector(s => s.game.metadata?.players)
  const config_show_equity = useSelector(s => s.game.metadata?.config_show_equity)
  const public_income = useSelector(s => s.game.metadata?.players[player.id].public_income) || 0
  const public_rating = useSelector(s => s.game.metadata?.players[player.id].public_credit_rating) || ''
  const connectionStatus = useSelector(s => s.game.connection_status[player.id])
  const [orbiting_info, planet] = player.current_planet.split(':')
  const [planetName] = planet.split('|')
  const public_equity = (players?.[player.id].public_equity) || 0
  let total_game_equity = 0
  if (players) {
    for (const [, player] of Object.entries(players)) {
      if (player.public_equity > 0) {
        total_game_equity += player.public_equity
      }
    }
  }
  const equity_percentage = (public_equity / total_game_equity) * 100
  const {
    onFocusPlayer,
  } = useFocusPlayer(player)

  let [orbiting_planet, info] = orbiting_info.split('|')
  if (orbiting_planet === 'R') {
    orbiting_planet = info
  }

  let color: string
  const choosing = players_choosing.indexOf(player.id) !== -1
  if (player.dead) {
    color = 'var(--prometheus-danger)'
  } else if (player.ready) {
    color = 'var(--prometheus-primary)'
  } else if (choosing) {
    color = 'var(--prometheus-warning)'
  } else {
    color = 'var(--prometheus-text-primary)'
  }

  return (
    <Card padding="sm" interactive onClick={onFocusPlayer} style={{ position: 'relative' }}>
      <Stack space="sm">
        <Stack direction="row" space="sm" style={{ alignItems: 'center', flexWrap: 'wrap' }}>
          <List.Icon style={{ color }} size="large" name="user" />
          <Typography style={{ color: player.color }} variant="h5">{player.name}</Typography>
          {!player.dead && (
            <Card style={{ padding: '0 var(--prometheus-spacing-xs)' }}>
              <Typography>Roll: {sum(player.roll || [])}</Typography>
            </Card>
          )}
          {player.dead && (
            <Card borderColor='danger' style={{ padding: '0 var(--prometheus-spacing-xs)' }}>
              <Typography color="danger" retro>VANQUISHED</Typography>
            </Card>
          )}
          {choosing && (
            <Card borderColor={'warning'} style={{ borderRadius: 'var(--prometheus-card-border-radius)', padding: '0 var(--prometheus-spacing-xs)' }}>
              <Typography>Choosing</Typography>
            </Card>
          )}
        </Stack>
        {!player.dead && (
          <>
            <Divider />
            <Stack space="xl" direction="row" style={{ flexWrap: 'wrap' }}>
              <Stack style={{ gap: 0 }}>
                <Typography style={{ lineHeight: 1.4 }}>Planet: <Typography style={{ lineHeight: 1.4 }} component="span" color="primary">{planetName}</Typography></Typography>
                <Typography style={{ lineHeight: 1.4 }}>Planets: <Typography style={{ lineHeight: 1.4 }} component="span" color="primary">{player.planets.length}</Typography></Typography>
                <Typography style={{ lineHeight: 1.4 }}>Rating: <Typography style={{ lineHeight: 1.4, borderRadius: '2px', padding: '0 2px', backgroundColor: findCreditRatingColor(public_rating), color: 'black' }} component="span">{public_rating}</Typography></Typography>
              </Stack>
              <Stack style={{ gap: 0, flexWrap: 'wrap' }}>
                <Typography style={{ lineHeight: 1.4 }}>Equity: <Typography style={{ lineHeight: 1.4 }} component="span" color={public_equity >= 0 ? 'primary' : 'danger' }>{truncateCash(public_equity, { raw: false }, true)}</Typography></Typography>
                <Typography style={{ lineHeight: 1.4 }}>Equity: <Typography style={{ lineHeight: 1.4 }} component="span" color={equity_percentage > 80 ? 'danger' : undefined}>{round(equity_percentage, 2)}%</Typography></Typography>
                <Typography style={{ lineHeight: 1.4 }}>Income: <Typography style={{ lineHeight: 1.4 }} component="span" color={public_income >= 0 ? 'primary' : 'danger'}>{truncateCash(public_income)}</Typography></Typography>
              </Stack>
            </Stack>
          </>
        )}
      </Stack>
      <div className={classNames('psl-disconnected', connectionStatus)}>
        <div>
          DISCONNECTED
        </div>
      </div>
      {/* <List.Content>
        {!player.dead && (<List.Header><span style={{ color: player.color }}>{player.name}</span> - Roll: {sum(player.roll || [])}{choosing && ' - Choosing'}</List.Header>)}
        {player.dead && (<List.Header>{player.name}</List.Header>)}
        {player.dead && (<List.Description>Vanquished</List.Description>)}
      </List.Content>
      <div className="PSL-splitter">
        <List.Content>
          {!player.dead && (<List.Description>Planet: {planetName}</List.Description>)}
          {!player.dead && (<List.Description>Owned Planets: {player.planets.length}</List.Description>)}
          {!player.dead && (
            <List.Description>
              Rating: <span style={{ backgroundColor: findCreditRatingColor(public_rating), padding: '0 2px', borderRadius: '2px' }}>{public_rating}</span>
            </List.Description>
          )}
        </List.Content>
        {(config_show_equity) && <List.Content>
          {!player.dead && (<List.Description>Equity: {truncateCash(public_equity, { raw: false }, true)}</List.Description>)}
          {!player.dead && (<List.Description>Equity: <span style={{ color: `${equity_percentage > 80 ? 'red' : ''}` }}>{round(equity_percentage, 2)}</span>%</List.Description>)}
          {!player.dead && (<List.Description >Income: <span style={{ color: `${public_income > 0 ? 'green' : 'red'}` }}>{truncateCash(public_income)}</span></List.Description>)}
        </List.Content>}
      </div>
      <div className={classNames('psl-disconnected', connectionStatus)}>
        <div>
          DISCONNECTED
        </div>
      </div> */}
    </Card>
  )
}

export const PlayerStatusList = () => {
  const _players = useSelector(s => s.game.metadata?.players) || {} as PlayerStatuses
  const players = [] as PlayerStatus[]
  const is_map = useSelector(s => s.game.galaxy_display)
  Object.keys(_players).forEach((uid) => {
    players.push(_players[uid])
  })
  players.sort((a, b) => a.name.localeCompare(b.name))
  return (
    <>
      <Card transparent className={classNames('jr-players', { is_map })} padding="sm" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderLeft: 'none', zIndex: 1 }}>
        <Stack space="sm">
          <Typography variant="h4" retro color="primary">VOYAGERS</Typography>
          <Cards>
            {players.map((player) => {
              return (
                <PlayerStatusListItem key={player.name} player={player} />
              )
            })}
          </Cards>
        </Stack>
      </Card>
    </>
  )
}
